import { AlertCircle } from 'lucide-react';

export function ProofTraction({ traction }) {
  const hasData = traction?.has_data && traction?.metrics?.length > 0;
  return (
    <section id="prova" className="acq-section">
      <div className="acq-container">
        <header>
          <span className="kicker">Prova e tração</span>
          <h2>Transparência sobre o histórico disponível.</h2>
        </header>
        <div className="body">
          {hasData ? (
            <div className="card-list">
              {traction.metrics.map((m) => (
                <article className="card" key={m.id}>
                  <h4>{m.label}</h4>
                  <p>{m.value}</p>
                </article>
              ))}
            </div>
          ) : (
            <div className="alert alert-warn" data-testid="proof-empty">
              <AlertCircle size={20} />
              <div>
                <strong>{traction?.note || 'Operação em fase inicial.'}</strong>
                <br />
                Vendas históricas, pedidos de contacto, demonstrações realizadas e taxa de conversão só serão
                divulgados quando estiverem documentados. Nenhum número será inventado para fins de apresentação.
              </div>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}
